// Loader.js
import React from 'react';
// import './Loader.css';  // Import the CSS for the loader

const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
